class Listener {
  //dã
  constructor() {
    this.elementsControler = {};
    this.elementsControlerRedux = {};
  }

  //reducao do objecto multidimensional do editor para um objeto simples
  reduxx(arr) {
    this.elementsControlerRedux[arr.id] = arr;
    if (typeof arr.childs != 'undefined' && arr.childs.length > 0) {
      for (let i in arr.childs)
        this.reduxx(arr.childs[i]);
    }
    return true;
  }

  //metodo recursivo para aplicacao das alteracoes no objeto multidimensional
  setChange(arrayGeneral, newObj, idEl) {
    for (var i in arrayGeneral) {
      if (arrayGeneral[i].id == idEl) {
        arrayGeneral[i] = newObj;
        return;
      }

      if (typeof arrayGeneral[i].childs != 'undefined' && arrayGeneral[i].childs.length > 0) {
        this.setChange(arrayGeneral[i].childs, newObj, idEl);
      }
    }
  }

  //funcao principal que mantem as referencias dos itens e preenche o objeto redux
  addElements(elements) {
    this.elementsControlerRedux = {};
    let elementsToRedux = Object.assign({}, elements);
    this.elementsControler = elements;

    for (let j in elementsToRedux) {
      this.reduxx(elementsToRedux[j], j)
    }
  }

  //put new ids without conflict on childs - recursive
  changeIdElementChilds(elements, parentID){
    let idCounter = 0

    const generateId = () => {
      return `${Date.now()}${idCounter++}`
    }

    const processElements = (elems, parentId, idPrefix) => {
      return elems.map((el) => {
        const newId = idPrefix + generateId()
        const cloned = { ...el, id: newId }

        cloned.config = { ...el.config, parent_id: parentId }
        if (Array.isArray(el.childs) && el.childs.length > 0) {
          cloned.childs = processElements(el.childs, newId, parseInt(Math.random() * 10000))
        }

        this.elementsControlerRedux[newId] = cloned
        return cloned
      })
    }

    return processElements(elements, parentID, parseInt(Math.random() * 10000))
  }

  //funcao de duplicar elements
  duplicateElement(parentId, obj) {
    if(typeof obj.childs != 'undefined' && obj.childs.length > 0)
      obj.childs = this.changeIdElementChilds(obj.childs, obj.id);

    if (typeof parentId === 'string') {
      parentId = parentId.replace('place-menu-', '');
    }

    this.elementsControlerRedux[parentId].childs.push(obj);
    obj.config.order_mobile = this.elementsControlerRedux[parentId].childs.length - 1;
    this.setChange(this.elementsControler, this.elementsControlerRedux[parentId], parentId);
    this.addElements(this.elementsControler);

    return this.elementsControler;
  }

  //funcao de duplicar panel
  duplicatePanel(panelId) {

    //deepclone
    let newPanel = JSON.parse(JSON.stringify(this.elementsControlerRedux[panelId]));
    let newId = Date.now() + parseInt(Math.random() * 10000);
    newPanel.id = newId;
    if(typeof newPanel.childs != 'undefined' && newPanel.childs.length > 0)
      newPanel.childs = this.changeIdElementChilds(newPanel.childs, newId);

    this.elementsControler.push(newPanel);
    this.addElements(this.elementsControler);
    return this.elementsControler;
  }

  //metodo assincrono para setar valores no elemento, sem gargalar
  async setValueElement(id, obj){
    this.elementsControlerRedux[id] = obj;

    await this.setChange(this.elementsControler, this.elementsControlerRedux[id], id);
  }

  //metodo assincrono para setar config no elemento, sem gargalar
  async setValueElementConfig(id, obj){
    if(typeof this.elementsControlerRedux[id] === 'undefined'){
      if(document.getElementById(id) != null)
        this.elementsControlerRedux[id] = {
          id: id,
          name: document.getElementById(id).getAttribute('element'),
          config: obj,
          childs: []
        };
    }else{
      this.elementsControlerRedux[id].config = obj;
    }

    await this.setChange(this.elementsControler, this.elementsControlerRedux[id], id);
  }

  toggleElement(id, device, value) {
      const element = this.elementsControlerRedux[id];
      if (!element || !element.config) return this.elementsControler;

      const isDesktop = device === 'desktop';
      const configKey = isDesktop ? 'showDesktop' : 'showMobile';
      const hideOrderKey = isDesktop ? 'hideDesktopOrder' : 'hideMobileOrder';

      // Clone
      const newConfig = { ...element.config };
      newConfig[configKey] = value;

      // Hide
      if (!value) {
          let lastHidden = 0;

          Object.values(this.elementsControlerRedux).forEach(el => {
              if (!el.config) return;

              const order = el.config[hideOrderKey] || 0;
              const isHidden = !el.config[configKey];

              if (isHidden) {
                  lastHidden = Math.max(lastHidden, order);
              }
          });

          newConfig[hideOrderKey] = lastHidden + 1;
      }

      // Show
      else {
          const oldOrder = newConfig[hideOrderKey] || 0;
          newConfig[hideOrderKey] = 0;

          if (oldOrder > 0) {
              Object.values(this.elementsControlerRedux).forEach(el => {
                  if (!el.config) return;

                  const order = el.config[hideOrderKey] || 0;

                  if (order > oldOrder) {
                      el.config[hideOrderKey] = order - 1;
                  }
              });
          }
      }

      // Update
      element.config = newConfig;

      this.setChange(this.elementsControler, element, id);
      return this.elementsControler;
  }

  addPanel(obj){

    //deepclone
    let newPanel = JSON.parse(JSON.stringify(obj));
    let newId = Date.now() + parseInt(Math.random() * 10000);
    newPanel.id = newId;
    if(typeof newPanel.childs != 'undefined' && newPanel.childs.length > 0)
      newPanel.childs = this.changeIdElementChilds(newPanel.childs, newId);

    this.elementsControler.push(newPanel);
    this.addElements(this.elementsControler);
    return this.elementsControler;

  }

  addElement(parentId, element) {

    let newElement = JSON.parse(JSON.stringify(element));
    let newId = element.id;

    if(typeof newElement.childs === 'string')
      newElement.childs = JSON.parse(newElement.childs);

    if(typeof newElement.childs != 'undefined' && newElement.childs.length > 0)
      newElement.childs = this.changeIdElementChilds(newElement.childs, newId);

    if (typeof parentId === 'string') {
      parentId = parentId.replace('place-menu-', '');
    }

    if(typeof this.elementsControlerRedux[parentId].childs === 'undefined'){
      this.elementsControlerRedux[parentId].childs = [];
    }

    this.elementsControlerRedux[newId] = newElement;
    this.elementsControlerRedux[parentId].childs.push(newElement);

    this.setChange(this.elementsControler, newElement, newId);
  }

  getElement(id) {
    return this.elementsControlerRedux[id];
  }

  getConfig(id) {
    return JSON.parse(JSON.stringify(this.elementsControlerRedux[id].config));
  }

  getChilds(parentId) {
    return JSON.parse(JSON.stringify(this.elementsControlerRedux[parentId].childs));
  }

  setChilds(parentId, childs) {
    this.elementsControlerRedux[parentId].childs = childs;
  }

  getElements() {
    return this.elementsControler;
  }

  getElementsRedux() {
    return this.elementsControlerRedux;
  }

}

export default Listener;



// WEBPACK FOOTER //
// ./src/js/base/Listener.js